export const classJoin = (arr, data = null) =>
  arr.map(item => (typeof item === 'function' ? item(data) : item)).join(' ');
